// extracted by mini-css-extract-plugin
export default {"cards":"feed_cards__Zdb4b"};